/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { X } from "lucide-react";
import { useGrowth } from "../../../context/GrowthContext";

const FIELDS = [
  { key: "name", label: "Organizer Name", placeholder: "Jane Smith", required: true },
  { key: "eventName", label: "Event Name", placeholder: "Louisville Night Market" },
  { key: "eventType", label: "Event Type", placeholder: "Farmers Market, Festival, Nightlife..." },
  { key: "email", label: "Email", placeholder: "jane@example.com", type: "email" },
  { key: "instagram", label: "Instagram", placeholder: "@louisvillenightmarket" },
  { key: "website", label: "Website", placeholder: "https://..." },
  { key: "city", label: "City", placeholder: "Louisville, KY" },
  { key: "estimatedVendorCount", label: "Est. Vendor Count", placeholder: "40", type: "number" },
  { key: "contactForm", label: "Contact Form URL", placeholder: "https://..." },
];

export default function AddLeadModal({ onClose }) {
  const { addLead } = useGrowth();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name?.trim()) {
      setError("Organizer name is required.");
      return;
    }
    setSaving(true);
    try {
      await addLead(form);
      onClose();
    } catch (err) {
      setError("Something went wrong. Try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-semibold text-gray-900">Add Lead</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 transition"
          >
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
          {FIELDS.map(({ key, label, placeholder, required, type }) => (
            <div key={key}>
              <label className="block text-xs font-medium text-gray-500 mb-1">
                {label} {required && <span className="text-red-400">*</span>}
              </label>
              <input
                type={type || "text"}
                value={form[key] || ""}
                onChange={(e) => set(key, e.target.value)}
                placeholder={placeholder}
                className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
              />
            </div>
          ))}

          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Notes</label>
            <textarea
              rows={2}
              value={form.notes || ""}
              onChange={(e) => set("notes", e.target.value)}
              placeholder="Any context — how you found them, what stood out..."
              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900 resize-none"
            />
          </div>

          {error && <p className="text-sm text-red-500">{error}</p>}
        </form>

        <div className="px-6 py-4 border-t border-gray-100 flex gap-3 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-900 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={saving}
            className="px-5 py-2 text-sm bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition disabled:opacity-50"
          >
            {saving ? "Adding..." : "Add Lead"}
          </button>
        </div>
      </div>
    </div>
  );
}
